import { FeatureDTO } from "./FeatureDTO";

export class NoPricingFeatureDTO extends FeatureDTO {
    constructor(sub?) {
        super(sub);
    }
}
